/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Category_TechnicalInputs */



/**
* | output |
* | --- |
* | "Technical" |
*
* @param {Qc_Category_TechnicalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_category_technical = /** @type {((inputs?: Qc_Category_TechnicalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Category_TechnicalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Technique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Technisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tecnico")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Технические")
	if (locale === "es") return /** @type {LocalizedString} */ ("Técnico")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("技术")
	if (locale === "ja") return /** @type {LocalizedString} */ ("技術")
	if (locale === "hi") return /** @type {LocalizedString} */ ("तकनीकी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Técnico")
	return /** @type {LocalizedString} */ ("Technical")
});